import axios from 'axios';
import LocalStorageService from './LocalStorageService';

const Request = axios.create();

Request.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      let refreshToken = '';
      const userToken = LocalStorageService.getCognitoItem('accessToken');
      if (userToken !== null) refreshToken = LocalStorageService.getCognitoItem('refreshToken');
      const refreshApi = `${process.env.ACCESS_TOKEN_URI}?grant_type=refresh_token&refresh_token=${refreshToken}`;
      const basicToken = window.btoa(`${process.env.CLIENT_ID}:${process.env.CLIENT_SECRET}`);
      const headers = {
        Authorization: `Basic ${basicToken}`,
      };
      return axios
        .post(refreshApi, undefined, { headers })
        .then(response => {
          const data = response.data;
          console.log(data);
          const user = {
            token: data.access_token,
            refreshToken: data.refresh_token,
            expires: Date.now() + data.expires_in * 1000,
          };

          LocalStorageService.setCognitoItem('accessToken', data.access_token);
          LocalStorageService.setCognitoItem('refreshToken', data.refresh_token);
          // LocalStorageService.setCognitoItem('expires', Date.now() + data.expires_in * 1000);
          originalRequest.headers.Authorization = `Bearer ${data.access_token}`;
          return Request(originalRequest);
        })
        .catch(err => {
          console.log(err);
          //window.location = '/logout';
        });
    }
    if (error.response?.status === 401 && originalRequest._retry) {
      //window.location = '/logout';
    }
    return Promise.reject(error);
  }
);

export default Request;
